import { defineComponent as _defineComponent } from 'vue'
import { VignetteRoutes } from "@/types";
import { useAppStore } from "@/pinia/app";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationFooter',
  setup(__props) {

const appStore = useAppStore();
const djangoSiteOrigin = computed(() => appStore.djangoSiteOrigin);

return { __sfc: true,appStore, djangoSiteOrigin, VignetteRoutes }
}

})